import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN, TRANSLATION_ANCILLARY_DETAILED, ANCILLARY_GROUP_PET_IN_CABIN_LIST, TRANSLATION_ANCILLARY_GROUP, EXTRAS_ANCILLARY_ANIMAL, BRAND_NAMES_MAP, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
var INDRADetailsPetsComponent = /** @class */ (function () {
    function INDRADetailsPetsComponent(sidebarService, route, router, bookingService, ibeAdminService, store, ancillaryCartService, bookingSearchService, ibeAdminConfigService) {
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.bookingService = bookingService;
        this.ibeAdminService = ibeAdminService;
        this.store = store;
        this.ancillaryCartService = ancillaryCartService;
        this.bookingSearchService = bookingSearchService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this._hasEdit = false;
        this.passengers = [];
        this.paxFareInfoFeatures = [];
        this.paxPurchaseFeatures = [];
        this.hasLayover = false;
        this.countUnit = '';
        this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE = 'whatsIncludedSidebars.';
        this.LOCAL_TRANSLATION_DETAILED_PETS = this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE + 'detailsPets.';
        this.showAddButton = true;
        this.isBookingView = false;
        this.isReviewTTTCompletion = false;
        if (this.router.url.includes('/my-bookings/view/'))
            this.isBookingView = true;
        if (this.router.url.includes('/review-your-trip/deeplink/'))
            this.isReviewTTTCompletion = true;
    }
    INDRADetailsPetsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
        this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
        this.passengers = this.bookingService.INDRA_getPaxInfo();
        this.hasLayover = this.INDRA_checkIndirectFlight();
        this.flightRouteInput = this.bookingService.INDRA_getFlightRoute(this.flight);
        this.ancillaryGroup = ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN;
        this.brandDescription = this.INDRA_getBrandDescription();
        var fareInfoAncillary = this.bookingService.INDRA_getPassengersAncillaryFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN, this.flight.idFlight.toString());
        //let purchasedAncillary = this.bookingService.INDRA_getPassengersPurchasedAncillary(ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN, this.flight.idFlight.toString(), this.flightIdentifier);
        var purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN, this.flight.idFlight.toString(), this.flightIdentifier);
        this.passengers.forEach(function (pax) {
            var _a, _b, _c;
            var fareInfoindex = fareInfoAncillary.findIndex(function (object) { return object[pax.idPax]; });
            var paxfareAncillaries = fareInfoAncillary[fareInfoindex];
            _this.paxFareInfoFeatures.push((_a = {},
                _a[pax.idPax] = _this.INDRA_constructAncillaryList(paxfareAncillaries[pax.idPax]),
                _a));
            ;
            var purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(function (object) { return object[pax.idPax]; });
            if (purchasedIndex === -1) {
                _this.paxPurchaseFeatures.push((_b = {},
                    _b[pax.idPax] = [],
                    _b));
            }
            else {
                var paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
                _this.paxPurchaseFeatures.push((_c = {},
                    _c[pax.idPax] = _this.INDRA_constructAncillaryListForPurchased(paxpurchasedAncillaries[pax.idPax]),
                    _c));
                //sort ascending based on segmentID
                _this.paxPurchaseFeatures.sort(function (first, second) { return (Number(first.segmentId) > Number(second.segmentId) ? -1 : 1); });
            }
        });
        this.INDRA_showAddButton();
    };
    INDRADetailsPetsComponent.prototype.INDRA_constructAncillaryList = function (list) {
        var _this = this;
        this.countUnit = this.INDRA_getTranslation(this.INDRA_getTranslationKey('countUnitSingular', 'texts'));
        var returnValue = '';
        list.forEach(function (item) {
            if (returnValue.length === 0) {
                returnValue = "1" + _this.countUnit + ' ' + _this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_DETAILED + item));
            }
            else {
                returnValue = returnValue + ', ' + "1" + _this.countUnit + ' ' + _this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_DETAILED + item));
            }
        });
        return returnValue;
    };
    INDRADetailsPetsComponent.prototype.INDRA_constructAncillaryListForPurchased = function (list) {
        var _this = this;
        var returnValue = [];
        list.forEach(function (segment) {
            var descriptionForSegment = '';
            // flag for unconfirmed codes
            var unconfirmed = false;
            segment.ancillaryList.forEach(function (ancillary) {
                if (ancillary.count > 1) {
                    _this.countUnit = _this.INDRA_getTranslation(_this.INDRA_getTranslationKey('countUnitPlural', 'texts'));
                }
                else {
                    _this.countUnit = _this.INDRA_getTranslation(_this.INDRA_getTranslationKey('countUnitSingular', 'texts'));
                }
                if (descriptionForSegment.length === 0) {
                    descriptionForSegment = ancillary.count + _this.countUnit + ' ' + _this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_DETAILED + ancillary.code + (ancillary.code === 'PETC' && ancillary.subCode ? ancillary.subCode : "")));
                }
                else {
                    descriptionForSegment = descriptionForSegment + ', ' + ancillary.count + _this.countUnit + ' ' + _this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_DETAILED + ancillary.code));
                }
                // ANCILLARIES WARNING
                if (ancillary.unconfirmed) {
                    unconfirmed = true;
                }
            });
            returnValue.push({
                ancillaryDetail: descriptionForSegment,
                segmentId: segment.segmentId,
                // ANCILLARIES WARNING
                unconfirmed: unconfirmed
            });
        });
        returnValue.sort(function (a, b) { return (a.segmentId > b.segmentId) ? 1 : -1; });
        return returnValue;
    };
    INDRADetailsPetsComponent.prototype.INDRA_getPurchasedAncillaryForPassenger = function (idPax) {
        var returnValue = [];
        var index = this.paxPurchaseFeatures.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (this.paxPurchaseFeatures) {
            var paxAncillary = this.paxPurchaseFeatures[index];
            returnValue = paxAncillary[idPax];
            return returnValue;
        }
    };
    INDRADetailsPetsComponent.prototype.INDRA_gotoURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    INDRADetailsPetsComponent.prototype.INDRA_displaySegmentInfo = function (segmentId) {
        var returnValue = '';
        if (this.hasLayover) {
            var segmentInfo = this.bookingService.INDRA_getSegment(this.flightIdentifier, segmentId);
            var segmentDeparture = this.bookingService.INDRA_getLocation(segmentInfo.departureAirport);
            var segmentArrival = this.bookingService.INDRA_getLocation(segmentInfo.arrivalAirport);
            returnValue = ' ' + segmentDeparture.city + ' - ' + segmentArrival.city;
        }
        return returnValue;
    };
    INDRADetailsPetsComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRADetailsPetsComponent.prototype.INDRA_getAncillaryForPassenger = function (list, idPax) {
        var returnValue;
        var index = list.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (list) {
            var paxAncillary = list[index];
            returnValue = paxAncillary[idPax];
            return returnValue;
        }
    };
    INDRADetailsPetsComponent.prototype.INDRA_printPassengerName = function (pax) {
        return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
    };
    INDRADetailsPetsComponent.prototype.INDRA_capitalize = function (str) {
        if (str.length > 0) {
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }
        return '';
    };
    INDRADetailsPetsComponent.prototype.INDRA_printBrand = function () {
        return this.brandDescription;
    };
    INDRADetailsPetsComponent.prototype.INDRA_getGroupLabel = function () {
        var groupList = ANCILLARY_GROUP_PET_IN_CABIN_LIST;
        return this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_GROUP + groupList[0]));
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRADetailsPetsComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
    };
    /** Handles close action intention **/
    INDRADetailsPetsComponent.prototype.INDRA_handleClose = function () { this.closeSidebar(); };
    INDRADetailsPetsComponent.prototype.openPetsSidebar = function () {
        this.sidebarService.openSidebar(['ancillaries--small-pets', { flight: this.flightIdentifier }]);
    };
    INDRADetailsPetsComponent.prototype.INDRA_getTranslationKey = function (lastKey, keyType) {
        return this.LOCAL_TRANSLATION_DETAILED_PETS + keyType + "." + lastKey;
    };
    INDRADetailsPetsComponent.prototype.INDRA_checkIndirectFlight = function () {
        var segments = this.bookingService.INDRA_getSegmentIDs(this.flightIdentifier);
        var flag = false;
        if (segments.length > 1) {
            flag = true;
        }
        return flag;
    };
    INDRADetailsPetsComponent.prototype.INDRA_checkIfCodeShare = function () {
        return (this.bookingService.INDRA_checkIfCodeShare(this.flight.listSegment) ? true : false);
    };
    INDRADetailsPetsComponent.prototype.INDRA_showAddButton = function () {
        var ancillaryAvailable = this.bookingService.INDRA_isAncillaryAvailable(EXTRAS_ANCILLARY_ANIMAL, this.flightIdentifier);
        if (!ancillaryAvailable) {
            this.showAddButton = false;
        }
    };
    INDRADetailsPetsComponent.prototype.INDRA_printImage = function () {
        var IMAGE = 'pets.jpg';
        return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
    };
    INDRADetailsPetsComponent.prototype.INDRA_getBrandDescription = function () {
        if (this.isBookingView || this.isReviewTTTCompletion) {
            if (!this.flight.fareFamily)
                return '';
            var brandCode = this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily);
            return brandCode ? BRAND_NAMES_MAP[brandCode] : '';
        }
        else {
            this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
        }
    };
    return INDRADetailsPetsComponent;
}());
export { INDRADetailsPetsComponent };
